export default "__VITE_ASSET__DJgSNTwe__"